import { createIcon } from '@chakra-ui/react';

export const ChevronLeftFirstIcon = createIcon({
  displayName: 'ChevronLeftFirstIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 6.5C8.67157 6.5 8 7.17157 8 8L8 25C8 25.8284 8.67157 26.5 9.5 26.5C10.3284 26.5 11 25.8284 11 25L11 8C11 7.17157 10.3284 6.5 9.5 6.5ZM23.5607 8.93873C24.1464 8.38083 24.1464 7.47631 23.5607 6.91842C22.9749 6.36053 22.0251 6.36053 21.4393 6.91842L12.4393 15.4898C11.8536 16.0477 11.8536 16.9523 12.4393 17.5102L21.4393 26.0816C22.0251 26.6395 22.9749 26.6395 23.5607 26.0816C24.1464 25.5237 24.1464 24.6192 23.5607 24.0613L15.6213 16.5L23.5607 8.93873Z'
      fill='currentColor'
    />
  ),
});
